import React, { FC, Fragment } from 'react';
import { Link, Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { ContentFragment } from 'api';
import { generateLink } from 'Links';

interface IProps extends WithStyles<typeof styles> {
  content: ContentFragment;
}

const MAX_TITLE_LENGTH = 100;
const MAX_DESCRIPTION_LENGTH = 255;

const styles = (theme: Theme) =>
  createStyles({
    text: theme.mixins.clamp(2),
  });

const UrlMetadata: FC<IProps> = ({ classes, content }) => {
  const { content_object } = content;
  let { description, title } = content_object.url_metadata;

  if (title && title.length > MAX_TITLE_LENGTH) {
    title = `${title.substring(0, MAX_TITLE_LENGTH)}...`;
  }

  if (description && description.length > MAX_DESCRIPTION_LENGTH) {
    description = `${description.substring(0, MAX_DESCRIPTION_LENGTH)}...`;
  }

  return (
    <Fragment>
      <Link
        className={classes.text}
        color="textPrimary"
        variant="subtitle2"
        component={generateLink(`/content/${content.content_id}`)}>
        {title}
      </Link>
      <Typography className={classes.text}>{description}</Typography>
    </Fragment>
  );
};

export default withStyles(styles)(UrlMetadata);
